"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/styles");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return (0, _styles.createStyles)({
    alertContainer: {
      zIndex: 5
    },
    alert: {
      backgroundColor: theme.palette.NEUTRAL500,
      boxSizing: 'border-box',
      boxShadow: theme.shadows[5],
      color: theme.palette.NEUTRAL000,
      width: '100%',
      zIndex: 600,
      borderRadius: 3,
      padding: theme.spacing(1, 2),
      transition: 'background-color 200ms ease 0s',
      display: 'flex',
      alignItems: 'center',
      minHeight: theme.spacing(7.5)
    },
    alertSmall: {
      minHeight: theme.spacing(2)
    },
    noShadow: {
      boxShadow: 'none'
    },
    alertSmallIcon: {
      fontSize: theme.typography.pxToRem(16),
      '& svg': {
        fontSize: 'inherit'
      }
    },
    alertInfo: {
      backgroundColor: theme.palette.BLUE400
    },
    alertSuccess: {
      backgroundColor: theme.palette.GREEN400
    },
    alertDanger: {
      backgroundColor: theme.palette.RED400
    },
    alertWarning: {
      color: theme.palette.NEUTRAL700,
      backgroundColor: theme.palette.YELLOW200
    },
    titleContainer: {
      display: 'flex',
      alignItems: 'center'
    },
    title: _defineProperty({
      fontSize: theme.typography.pxToRem(14),
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      fontWeight: theme.typography.fontWeightMedium
    }, theme.breakpoints.down('sm'), {
      textAlign: 'center',
      paddingBottom: theme.spacing(1)
    }),
    content: _defineProperty({
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%'
    }, theme.breakpoints.down('sm'), {
      flexDirection: 'column',
      alignItems: 'center'
    }),
    actions: {
      display: 'flex',
      justifyContent: 'space-between'
    }
  });
});
var _default = useStyles;
exports.default = _default;